export enum LegListDepartureTimeType {
  UTC = 1,
  Local = 2,
}
